(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Vue"));
	else if(typeof define === 'function' && define.amd)
		define(["Vue"], factory);
	else if(typeof exports === 'object')
		exports["VueSvgInlineComponent"] = factory(require("Vue"));
	else
		root["VueSvgInlineComponent"] = factory(root["Vue"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__5__) {
return 